<main class="legal-page" role="main">
    <div class="legal-page-column">
        <h1 id="data-security-title" class="legal-page-title">{{ 'LEGAL.TITLE.DATA-SECURITY' | translate }}</h1>
        <article class="legal-card" role="article" [attr.aria-labelledby]="'data-security-title'">
            <section role="region"
                     [attr.aria-label]="'ACCESSIBILITY.LEGAL_CONTENT' | translate"
                     [innerHTML]="bodyText$ | async | translate">
            </section>
        </article>
    </div>
</main>
